module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "date-order-windows"
  }, [(_vm.orderWindowDate) ? _c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 row"
  }, [_c('div', {
    staticClass: "orders-windows-created col-md-6 col-xs-12"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("orders.labelCreated")) + " " + _vm._s(_vm.orderWindowDate.createdAt) + " " + _vm._s(_vm.$t("orders.labelCreatedBy")) + "\n            " + _vm._s(_vm.fullNameFormat(_vm.orderWindowDate.createdBy)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "orders-windows-update col-md-6 col-xs-12"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("orders.labelLastUpdate")) + " " + _vm._s(_vm.orderWindowDate.modifiedDate) + " " + _vm._s(_vm.$t("orders.labelLastUpdateBy")) + "\n            " + _vm._s(_vm.fullNameFormat(_vm.orderWindowDate.modifiedBy)) + "\n        ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50c346c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/summary-common/dateOrderWindows.vue
// module id = 3180
// module chunks = 0